// extracted by mini-css-extract-plugin
module.exports = {"container":"premium-ProceedToPayment__container--3hR2R","btn":"premium-ProceedToPayment__btn--66JKM","tooltip":"premium-ProceedToPayment__tooltip--35uSe"};